import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '@/views/LoginView.vue';
import axios from 'axios';
import ErrorView from '@/views/ErrorView.vue';

import { useUserStore } from '@/stores/user-store';
import ModuleLicenseAdd from '@/views/license/ModuleLicenseAdd.vue';
import UserList from '@/views/user/UserList.vue';
import UserAdd from '@/views/user/UserAdd.vue';
import ModuleLicenseList from '@/views/license/ModuleLicenseList.vue';
import LandingPage from '@/LandingPage.vue';
import DexlibLicenseList from '@/views/license/DexlibLicenseList.vue';
import DexlibLicenseAdd from '@/views/license/DexlibLicenseAdd.vue';
import ProfileEdit from '@/views/user/ProfileEdit.vue';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { requiresNoAuth: true },
    },
    {
      path: '/',
      name: 'landing-page',
      component: LandingPage,
    },
    {
      path: '/module-licenses',
      name: 'module-license-list',
      component: ModuleLicenseList,
    },
    {
      path: '/module-licenses/add',
      name: 'module-license-add',
      component: ModuleLicenseAdd,
    },
    {
      path: '/dexlib-licenses',
      name: 'dexlib-license-list',
      component: DexlibLicenseList,
    },
    {
      path: '/dexlib-licenses/add',
      name: 'dexlib-license-add',
      component: DexlibLicenseAdd,
    },
    {
      path: '/users',
      name: 'user-list',
      component: UserList,
    },
    {
      path: '/users/add',
      name: 'user-add',
      component: UserAdd,
    },
    {
      path: '/profile-edit',
      name: 'profile-edit',
      component: ProfileEdit,
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorView,
      meta: { requiresNoAuth: true },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.meta?.requiresNoAuth) {
    return next();
  }

  try {
    const userStore = useUserStore();

    try {
      const user = (
        await axios({
          method: 'GET',
          url: '/api/profile',
        })
      ).data;
      userStore.user = user;
      console.log('user', user);
    } catch (error) {
      if (error.response?.status === 401) {
        return next({ name: 'login', query: { from: to.fullPath } });
      }
      console.error(error);
      return next({ name: 'error' });
    }
  } catch (error) {
    console.error(error);
    return next({ name: 'error' });
  }

  return next();
});
